module.exports = {
	"AdUnit": {
		"ad_label": "Annons"
	},
	"Article": {
		"by": "Av",
		"related_news": "Relaterade nyheter"
	},
	"ArticleShare": {
		"share_article": "Dela artikel"
	},
	"PopularVideos": {
		"most_viewed": "Mest sett"
	},
	"AuthorInfo": {
		"show_all": "Visa alla"
	},
	"BlogIndex": {
		"heading1": "Alla",
		"heading2": "Bloggar",
		"show_more": "Visa fler inlägg från"
	},
	"ContentMeta": {
		"all": "Alla",
		"goals": "Mål",
		"game": "Match",
		"summary": "Sammandrag",
		"highlight": "Höjdpunkt",
		"coverage": "Reportage",
		"studio": "Studio",
		"program": "Program",
		"top-list": "Topplista",
		"interview": "Intervju",
		"live": "Live",
		"48hclip": " ",
		"vce-clip": " "
	},
	"CookieNotification": {
		"close": "Stäng"
	},
	"EmbedPlayer": {
		"not_found": "Sidan finns tyvärr inte"
	},
	"ExpandableBox": {
		"show_more": "Visa mer"
	},
	"FeedContainerBig": {
		"extra": "Extra",
		"top_news": "Senaste nytt",
		"blog": "Blogg",
		"podcast": "Podcast"
	},
	"FbCommentBox": {
		"show_comments": "Visa kommentarer"
	},
	"FollowFacebook": {
		"heading": "Följ oss på Facebook",
		"social_blurb": "Håll dig uppdaterad"
	},
	"FollowMail": {
		"email_label": "Fyll i din e-postadress",
		"heading": "Prenumerera på vårt nyhetsbrev",
		"see_examples": "Se exempel",
		"sign_up": "Skicka",
		"social_blurb": "Håll dig uppdaterad",
		"viaplay_option_description": "Det senaste om TV, film och sport",
		"viaplay_option_title": "Viaplay nyhetsbrev",
		"viasport_option_description": "Sportnyheter levererade en gång i veckan",
		"viasport_option_title": "Viasat Sports nyhetsbrev"
	},
	"FollowTwitter": {
		"heading": "Följ oss på Twitter",
		"social_blurb": "Håll dig uppdaterad"
	},
	"LeagueIndex": {
		"heading": "Ligor"
	},
	"LeagueTables": {
		"result": "Resultat",
		"table": "Tabell"
	},
	"LiveScoreIndex": {
		"heading": "Livescore"
	},
	"LiveStreamListing": {
		"live": "Live",
		"today": "I dag",
		"tomorrow": "I morgon"
	},
	"Login": {
		"forgot": "Glömt användarnamn eller lösenord?",
		"heading": "Logga in",
		"login_button": "Logga in",
		"login_w_fb": "Logga in med Facebook",
		"or": "eller",
		"password": "Lösenord",
		"username": "Användarnamn",
		"email": "E-post",
		"coming_soon": "Inloggningsområdet lanseras inom kort. Inloggade användare kommer få tillgång till mängder av webbexklusivt sportinnehåll helt gratis. Skriv in din e-postadress nedan så håller vi dig uppdaterad.",
		"notify_me": "Skicka",
		"registration_complete": "E-post registrerad!"
	},
	"Mail": {
		"email": "E-post"
	},
	"MobileNav": {
		"social_blurb": "Håll dig uppdaterad"
	},
	"Modal": {
		"close": "Stäng"
	},
	"Navbar": {
		"video": "Klipp",
		"login": "Logga in",
		"menu": "Meny",
		"popular_teams": "Populära lag",
		"popular_leagues": "Populära ligor"
	},
	"NoMatch": {
		"heading": "404",
		"body": "We couldn't find the page you were looking for. You may have mistyped the address or the page may have been moved.",
		"viasport_startpage": "Return to the start page"
	},
	"Notifications": {
		"close": "Stäng",
		"country_warning": "Vi ser att du besöker vår site från ett annat land än Sverige. Av upphovsrättsliga skäl kan vissa videos vara otillgängliga för dig."
	},
	"PageHeading": {
		"news": "Nyheter"
	},
	"PodcastIndex": {
		"heading1": "Alla",
		"heading2": "Podcasts",
		"show_more": "Visa alla avsnitt av"
	},
	"Poll": {
		"button": "Rösta",
		"error": "Problem med att spara röstningen."
	},
	"SearchForm": {
		"cancel": "Avbryt"
	},
	"SearchPage": {
		"results_for": "Sökresultat för"
	},
	"Signup": {
		"heading": "Nytt konto",
		"register_button": "Skapa konto",
		"or": "eller",
		"password": "Lösenord",
		"signup_w_fb": "Skapa konto med Facebook",
		"username": "Användarnamn"
	},
	"SocialArea": {
		"email": "Epost",
		"social_blurb": "Håll dig uppdaterad"
	},
	"StoryNav": {
		"next": "Nästa artikel"
	},
	"TablesIndex": {
		"heading": "Tabeller"
	},
	"TeamIndex": {
		"heading": "Lag",
		"popular_teams": "Populära lag"
	},
	"TotalShares": {
		"total_shares": "Antal delningar"
	},
	"TvGuide": {
		"heading": "TV-guide"
	},
	"TwitterFollowWidget": {
		"follow": "Följ"
	},
	"UnsupportedBrowser": {
		"heading": "Oj, din webbläsare är för gammal och stödjs inte av viasatsport.se",
		"body": "Viasatsport.se fungerar med flertal olika webbläsare. Däremot behöver du uppgradera din webbläsare för att säkerställa att allt fungerar som det ska.",
		"meta": "Här har vi listat några av de vanligaste webbläsarna som vi stödjer.",
		"close": "Stäng"
	},
	"UserArea": {
		"login": "Logga in",
		"signup": "Registrera",
		"login_blurb": "Få åtkomst till premiuminnehåll"
	},
	"ViaplayLiveFeed": {
		"text": "Se sport i världsklass - live och i efterhand.",
		"button": "Skaffa Viaplay",
		"highlight_streams": "Huvudsändningar",
		"all_streams": "Alla",
		"link": "http://viaplay.se/sport",
		"linkText": "Se alla sändningar på viaplay.se"
	},
	"VideoIndex": {
		"show_clip": "Visa klipp",
		"show_clips": "Visa alla",
		"show_clips_2": "klipp",
		"summary": "Alla sammandrag från",
		"clip": "Klipp",
		"clips": "Klipp",
		"heading": "Matchklipp",
		"no_events_for_date": "Inga händelser för det här datumet",
		"no_events": "Det finns inga händelser",
		"today": "i dag",
		"yesterday": "i går"
	},
	"VideoPlayer": {
		"watch_again": "Spela video igen",
		"related_videos": "Relaterade klipp",
		"unsupported_browser": "Hej! Vi ser att du använder en webbläsare som vi inte stödjer. För att fortsätta titta rekommenderar vi att du",
		"chrome_link_text": "laddar hem webbläsaren Google Chrome",
		"video_expired": "Vi beklagar, men denna videos publiceringstid är begränsad till 48 timmar och den är inte längre tillgänglig"
	},
	"WidgetIndex": {
		"player_info": "Spelarinformation",
		"squad_stats": "Laginformation"
	},
	"InfiniteScroll": {
		"no_more_articles": "Du har nått slutet av flödet."
	},
	"Premium": {
		"heading": "Premium"
	},
	"Thumbnail": {
		"playing": "Spelas nu"
	},
	"Feedback": {
		"widgetTitle": "Dela dina tankar",
		"formTitle": "Generellt betyg",
		"message": "Vad kan vi förbättra?",
		"name": "Namn",
		"email": "Email - (ingen spam)",
		"notify": "Är du intresserad av att vara med på användartester på vårt huvudkontor i Stockholm?",
		"close": "Stäng",
		"send": "Skicka"
	}
};


//////////////////
// WEBPACK FOOTER
// ./l10n/sv.json
// module id = 695
// module chunks = 6